<template>
  <div>
    <div class="row">
      <ExistenciasModalComponent />
      <InventarioPosicionProductoModalComponent />
      <!-- Boton de acciones flotantes start  -->
      <div class="fab fab-12">
        <div @click="abrirModalOpciones()" class="btn-round">
          <i id="addIcon"><i class="fas fa-bars"></i></i>
        </div>
      </div>
      <!-- Boton de acciones flotantes END  -->
      <div class="col-12" v-if="error_finalizar">
        <small class="form-text text-danger">
          {{ error_finalizar }}
        </small>
      </div>
    </div>
    <div
      class="modal fade"
      id="estacionarProducto"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Estacionar Producto</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true"> ×</span>
            </button>
          </div>
          <form @submit="estacionarProductoATarea">
            <div class="modal-body">
              <div class="form-group">
                <label for=""> Estacion</label>
                <input
                  id="barra_estacion"
                  class="form-control text-center"
                  placeholder="Estacion"
                  v-model="barra_estacion"
                  required
                  type="text"
                />
                <small v-if="error_estacion" class="form-text text-danger">
                  {{ error_estacion }}
                </small>
              </div>
              <button class="btn btn-block btn-primary" type="submit">
                Aceptar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="motivoNoPickingModal"
      role="dialog"
      tabindex="-1"
      aria-hidden="true"
      style="display: none"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-center">Motivo del ¿porque no se pickeo?</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true"> ×</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12 text-center">
              <span
                style="font-size: 16px; color: black"
                v-if="no_picking.producto"
              >
                Pendientes de justificar:
              </span>
              <span
                style="font-size: 16px; color: blue"
                v-if="no_picking.producto"
              >
                {{ no_picking.pendiente }}
              </span>
            </div>
            <div class="col-12 text-center">
              <span
                style="font-size: 16px; color: green"
                v-if="no_picking.producto"
              >
                {{ no_picking.producto.sku }} -
              </span>
              <span
                style="font-size: 16px; color: green"
                v-if="no_picking.producto"
              >
                {{ no_picking.producto.nombre }}
              </span>
            </div>
            <!-------------------- Tabla de Resultados -------------------->
            <div class="col-12">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Descripción</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="d in motivos"
                    v-bind:key="d.id"
                    :value="d"
                    @click="eleccionNoPicking(d)"
                  >
                    <td>{{ d.descripcion }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-------------------- END - Basic Table -------------------->
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalOpciones"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button
              class="activity-box btn-sm btn-block btn-danger"
              style="margin-top: 0.14rem; padding: 0.4rem"
              @click="finalizarTarea()"
            >
              <div class="activity-avatar">
                <i class="fa fa-check-circle"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Finalizar</span>
              </div>
            </button>
            <hr />
            <button
              class="activity-box btn-sm btn-block"
              style="margin-top: 0.14rem; padding: 0.4rem"
              @click="abrirModalEstacionar()"
            >
              <div class="activity-avatar">
                <i class="fa fa-shopping-basket"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Estacionar</span>
              </div>
            </button>
            <button
              class="activity-box btn-sm btn-block"
              style="margin-top: 0.14rem; padding: 0.4rem"
              @click="inventarioXposicionXproducto()"
            >
              <div class="activity-avatar">
                <i class="fa fa-star"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Inv de posición producto</span>
              </div>
            </button>
            <button
              class="activity-box btn-sm btn-block"
              style="margin-top: 0.14rem; padding: 0.4rem"
              @click="verInventarioDePosicion()"
            >
              <div class="activity-avatar">
                <i class="fas fa-cubes"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Inventario de posición</span>
              </div>
            </button>
            <button
              class="activity-box btn-sm btn-block"
              style="margin-top: 0.14rem; padding: 0.4rem"
              @click="abrirLog()"
            >
              <div class="activity-avatar">
                <i class="fas fa-history"></i>
              </div>
              <div class="activity-info">
                <span class="font-weight-bold">Ver log</span>
              </div>
            </button>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              ref="cerrarModal"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import ExistenciasModalComponent from "@/components/commons/ExistenciasModalComponent";
import InventarioPosicionProductoModalComponent from "@/components/commons/InventarioPosicionProductoModalComponent";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    ExistenciasModalComponent,
    InventarioPosicionProductoModalComponent,
  },
  props: {
    id_tarea: {
      type: String,
    },
  },
  data() {
    return {
      barra_estacion: "",
      error_estacion: null,
      error_finalizar: null,
      no_picking: "",
      motivos: "",
      motivo_no_picking: "",
    };
  },
  mounted() {
    $("#estacionarProducto").on("shown.bs.modal", function () {
      $("#barra_estacion").trigger("focus");
    });
    this.refreshMotivosDevolucion();
  },
  methods: {
    abrirModalOpciones() {
      $("#modalOpciones").modal("show");
    },
    eleccionNoPicking(d) {
      let self = this;
      Notifications.alert.confirm(
        "¿Esta seguro de elegir esa opción?",
        "",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "tareas",
            self.id_tarea,
            "eleccion_no_picking",
            {
              id_: self.no_picking.id,
              motivo_no_picking: d.id,
            }
          )
            .then((res) => {
              self.no_picking = res.data;
              Notifications.toast.success(
                "Guardar motivo no picking",
                "Realizado correctamente"
              );

              self.finalizarTarea_();
              //self.$emit("refresh_tarea_finalizada");
            })
            .catch((err) => {
              console.log(err.response.data);
              if (err.response.data.detail) {
                self.error_finalizar = err.response.data.detail;
              }
            });
        }
      );
    },
    abrirModalEstacionar() {
      let self = this;
      $("#modalOpciones").modal("hide");
      $("#estacionarProducto").modal("show");
    },
    inventarioXposicionXproducto() {
      $("#modalOpciones").modal("hide");
      $("#modalInventarioXposicionXproducto").modal("show");
    },
    abrirLog() {
      $("#modalOpciones").modal("hide");
      this.$emit("abrirLog");
    },
    verInventarioDePosicion() {
      $("#modalOpciones").modal("hide");
      $("#modalBarraPosicion").modal("show");
    },
    estacionarProductoATarea(e) {
      e.preventDefault();
      let self = this;
      DynamicService.postAction(
        "wms",
        "tareas",
        self.id_tarea,
        "asignar_a_estacion",
        {
          barra: self.barra_estacion,
        }
      )
        .then((res) => {
          self.barra_estacion = "";
          $("#estacionarProducto").modal("hide");
          $("#barra_estacion").focus();
          self.$emit("refresh_tarea");
          Notifications.toast.success(
            "Asignar producto a estación",
            "Realizado correctamente"
          );
        })
        .catch((err) => {
          self.barra_estacion = "";
          $("#barra_estacion").focus();
          if (err.response.data.detail) {
            self.error_estacion = err.response.data.detail;
          }
        });
    },
    refreshMotivosDevolucion() {
      let self = this;
      DynamicService.fetch("wms", "motivo-no-picking").then((response) => {
        self.motivos = response.data.results;
      });
    },
    finalizarTarea_() {
      let self = this;
      DynamicService.postAction(
        "wms",
        "tareas",
        self.id_tarea,
        "revision_no_pickeados",
        {}
      )
        .then((res) => {
          self.no_picking = res.data;
          if (self.no_picking.pendiente > 0) {
            self.$emit("refresh_tarea");
            $("#motivoNoPickingModal").modal("show");
          } else {
            Vue.nextTick(function () {
              self.$emit("refresh_tarea_finalizada");
            });
            $("#motivoNoPickingModal").modal("hide");
            Notifications.toast.success(
              "Finalizar Tarea",
              "Realizado correctamente"
            );
          }
        })
        .catch((err) => {
          console.log(err.response.data);
          if (err.response.data.detail) {
            self.error_finalizar = err.response.data.detail;
          }
        });
    },
    finalizarTarea() {
      let self = this;
      $("#modalOpciones").modal("hide");
      Notifications.alert.confirm_danger(
        "Antes se analizará que productos no fueron pickeados",
        "¿Quiere seguir con finalizar la tarea?",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "tareas",
            self.id_tarea,
            "revision_no_pickeados",
            {}
          )
            .then((res) => {
              self.no_picking = res.data;
              console.log(self.no_picking);
              if (self.no_picking.pendiente > 0) {
                $("#motivoNoPickingModal").modal("show");
              } else {
                $("#motivoNoPickingModal").modal("hide");
                Notifications.toast.success(
                  "Finalizar Tarea",
                  "Realizado correctamente"
                );
                self.$emit("refresh_tarea_finalizada");
              }
            })
            .catch((err) => {
              console.log(err.response.data);
              if (err.response.data.detail) {
                self.error_finalizar = err.response.data.detail;
              }
            });
        }
      );
    },
  },
};
</script>
